import { render, staticRenderFns } from "./ModalDeleteSection.vue?vue&type=template&id=758b61a2&scoped=true&"
import script from "./ModalDeleteSection.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b61a2",
  null
  
)

export default component.exports